import React, { useContext, useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow, faRobot } from "@fortawesome/free-solid-svg-icons";
import "./chatbot.css"; // Ensure to include the new CSS for hiding the scrollbar
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import axios from "axios";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import ImageComponent from "../articales/ImageComponent";

const Chatbot = () => {
  const authContext = useContext(AuthContext);

  const questions = [
    "How are you today?",
    "Tell me how you feel.",
    "How was your day?",
    "Can you tell me what happened today?",
    "How about your school/college?",
    "Are you happy with your life? (Explain why)",
    "Tell me what are you going to do tomorrow.",
    "What are your plans for the weekend?",
    "Do you have any hobbies or interests?",
    "Is there something bothering you?",
  ];

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const navigate = useNavigate();
  const [chatHistory, setChatHistory] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [questionsFinished, setQuestionsFinished] = useState(false);
  const lastChatEntryRef = useRef(null);

  const handleQuestionsAndAnswers = async (e) => {
    e.preventDefault();
    const answer = e.target.elements.answer.value;
    if (answer.trim() !== "" && !questionsFinished) {
      const updatedChatHistory = [
        ...chatHistory,
        { question: questions[currentQuestionIndex], answer },
      ];
      setChatHistory(updatedChatHistory);
      e.target.elements.answer.value = "";

      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
      } else {
        setQuestionsFinished(true);
        const payload = {
          texts: updatedChatHistory.map((entry) => entry.answer),
        };
        setIsLoading(true);

        try {
          const response = await axios.post(
            "https://sentment-analysis.onrender.com/predict-sentiment",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.status === 200) {
            console.log("Data sent successfully");
            console.log(response.data);
            setResult(response.data); 
          } else {
            console.error("Failed to send data");
          }
        } catch (error) {
          console.error("Error:", error);
        } finally {
          setIsLoading(false);
          setShowModal(true);
        }
      }
    }
  };

  useEffect(() => {
    if (lastChatEntryRef.current) {
      lastChatEntryRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatHistory]);

  const handleClose = () => {
    setShowModal(false);
    navigate("/");
  };

  return (
    <>
      <div
        className="container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          height: "90vh",
          width: "100vw",
        }}
        id="chatbot"
      >
        <div className="w-100  d-flex flex-row align-items-center justify-content-between  mb-5">
          <div className="">
            <h5 className="mt-4">ChatBot 1.0</h5>
          </div>
          <div className="">
            <div className="mt-3 px-2 py-2 d-flex justify-content-end test-btn-container">
              <Link to="/" className="btn test-btn">
                End
              </Link>
            </div>
          </div>
        </div>

        <div className="w-100">
          <div className="col-md-8 m-auto">
            <div className="chat-container">
              {chatHistory.map((entry, index) => (
                <div key={index} className="chat-entry">
                  <div className="d-flex justify-content-between align-items-center">
                    <div
                      style={{
                        border: "1px solid #eee",
                        width: "50px",
                        height: "40px",
                        borderRadius: "30%",
                        padding: "3px 5px",
                        fontSize: "20px",
                        textAlign: "center",
                        color: "black",
                        backgroundColor: "#EEE",
                        marginRight: "10px",
                      }}
                    >
                      <FontAwesomeIcon icon={faRobot} />
                    </div>

                    <div
                      className="question border rounded px-4 py-3 mt-2 mb-1 w-100"
                      style={{ backgroundColor: "#eee" }}
                    >
                      {entry.question}
                    </div>
                  </div>
                  <div
                    className="pt-5"
                    style={{
                      direction: "rtl",
                      display: "flex",
                      alignItems: "center",
                      marginRight: "-10px",
                    }}
                  >
                    {authContext.auth && authContext.auth.token && (
                      <Link
                        to="/account"
                        className=" rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#0f5bc5",
                          color: "white",
                          fontSize: "33px",
                          fontWeight: "bold",
                          width: "50px",
                          height: "50px",
                          marginTop: "-32px",
                          marginLeft: "10px",
                        }}
                      >
                  <ImageComponent base64String={authContext?.auth?.picture} height={"100%"} border={'100%'}/>
                      </Link>
                    )}
                    <div
                      className="answer border rounded px-4 py-3 mt-3 mb-5 w-50"
                      style={{
                        backgroundColor: "#b0c6f296",
                        color: "#4e4040",
                        direction: "ltr",
                      }}
                    >
                      {entry.answer}
                    </div>
                  </div>
                </div>
              ))}
              {currentQuestionIndex < questions.length && !questionsFinished && (
                <div className="chat-entry w-100 d-flex justify-content-between align-items-center">
                  <div
                    style={{
                      border: "1px solid #eee",
                      width: "50px",
                      height: "40px",
                      borderRadius: "30%",
                      padding: "3px 5px",
                      fontSize: "20px",
                      textAlign: "center",
                      color: "black",
                      backgroundColor: "#EEE",
                      marginRight: "10px",
                    }}
                  >
                    <FontAwesomeIcon icon={faRobot} />
                  </div>
                  <div
                    className="question border rounded px-4 py-3 mt-2 mb-0 w-100"
                    style={{ backgroundColor: "#eee" }}
                  >
                    {questions[currentQuestionIndex]}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="mx-auto my-2   w-100">
          <div ref={lastChatEntryRef}></div>

          <form className=" w-100" onSubmit={handleQuestionsAndAnswers}>
            <div className="text-center w-100 mb-4">
              <input
                className=" focusInput align-items-center chat-input   py-3 px-3 mt-3 m-auto"
                type="text"
                style={{ fontSize: "16px", width: "90%" }}
                name="answer"
                placeholder="Type your answer..."
              />
              <button
                style={{
                  marginLeft: "-40px",
                  backgroundColor: "#FFF",
                  border: "1px solid transparent",
                  borderLeft: "transparent",
                  color: "#25e",
                  fontSize: "25px",
                }}
                type="submit"
                className="chat-submit px-1"
              >
                <FontAwesomeIcon icon={faLocationArrow} />
              </button>
            </div>
          </form>
        </div>
        {isLoading && (
          <div className="loader-container d-flex justify-content-center align-items-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}

        {showModal && (
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content rounded " style={{backgroundColor:"#fff"}}>
                <div className="modal-header   d-flex justify-content-center bg-primary align-items-center" 
                style={{borderBottom:"1px soild #eee"}}
                >
                  <h5
                    className="modal-title "
                    style={{  color: "white",fontSize:"35px" ,backgroundColor:"transparent"}}
                  >
                    <FontAwesomeIcon style={{fontSize:"60px"}} icon={faCircleCheck}/>
                  </h5>
              
                </div>
                <div className="modal-body py-2 d-flex flex-column justify-content-between align-items-center ">
                  <span className="my-3 rounded px-3 py-2 " style={
                    {}
                  }>Result</span> <p style={{fontSize:"17px",color:"#eb3d3d"}} > {result.details}</p>
                </div>
                <div className="modal-footer border-shadow  d-flex align-items-center justify-content-center"
                style={{borderTop:"2px solid #eee"}}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleClose}
                  >
                    Back to home
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Chatbot;
